import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Box, Typography } from '@mui/material';
import { CustomReactSelect } from '../../../shared';
import { actions as companyActions } from '../../../../redux/reducers/companyReducer';

const FilterBar = (props) => {
    const { companyOptions, company } = useSelector((state) => state.company);
    const dispatch = useDispatch();
    const { setCompany } = companyActions;

    const handleCompanyChange = (option) => {
        dispatch(setCompany(option));
    };

    return (
        <Grid className="flex-row gap-12 mb-24px mt-10px">
            <Box className="w-25">
                <CustomReactSelect
                    options={companyOptions}
                    handleFilter={handleCompanyChange}
                    selectedOption={{
                        label: company.name,
                        value: company.id,
                    }}
                    customStyle={{ borderRadius: '50px' }}
                    placeholder="Select Company"
                />
            </Box>
        </Grid>
    );
};

export default FilterBar;
